import { ErrorHandlerCaller as EHC, DEFAULTS_HANDLERS } from "@/utils/errors"
import { HTTP } from "@/utils/http-common"

export default {
  async getAll($) {
    const path = `/business/shops`
    let results = (await HTTP.get(path)).data
    return results
  },
  async getprincipalAll() {
    const path = `/business/shops/principal`
    let results = (await HTTP.get(path)).data
    return results
  },
  async getAdminprincipalAll() {
    const path = `/business/shops/admin`
    let results = (await HTTP.get(path)).data
    return results
  },

  async get(actionId) {
    const path = `/business/shops/${actionId}`
    return (await HTTP.get(path)).data
  },

  async post(notification_object) {
    return new Promise((resolve, reject) => {
      HTTP.post(`business/shops`, notification_object)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          return reject(error)
        })
    })
  },

  async authorize(shopId) {
    return new Promise((resolve, reject) => {
      HTTP.post(`business/shops/${shopId}/approved`)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          return reject(error)
        })
    })
  },

  async reject(shopId) {
    return new Promise((resolve, reject) => {
      HTTP.post(`business/shops/${shopId}/rejected`)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          return reject(error)
        })
    })
  },

  async put(data) {
    const { id, ...others } = data
    const path = `/business/shops/${id}`
    return (await HTTP.put(path, others)).data
  },

  async delete(actionId) {
    const path = `/business/shops/${actionId}`
    return (await HTTP.delete(path)).data
  }
}
